import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EncryptionService } from '../encryption/encryption.service';
import { environment } from '../../../../environments/environment';
import { StorageKeys } from '../../../util/constants';
import { hasAuthTokens } from '../../../util/auth-tokens.util';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {

  constructor(private readonly  encryptionService: EncryptionService) { }
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url?.includes(environment.cva_url) && request.body) {
      this.encryptionService.encryptAllTextFields(request.body)
    }

    let headers = request.headers;

    if (hasAuthTokens()) {
      headers = headers
        .set('authorization', `Bearer ${localStorage.getItem('idToken')!.trim()}`)
        .set('x-authorization-token', localStorage.getItem('authToken')!.trim());
    }

    const reqClone = request.clone({
      withCredentials: true,
      headers: headers.set('x-facility-code', localStorage.getItem(StorageKeys.FACILITY_CODE) ?? '')
    });
    return next.handle(reqClone);
  }
}
